;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputUsers', inputUsers)

  /* @ngInject */
  function inputUsers () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        modelPropertyName: '@',
        model: '=',
        loading: '<',
        users: '<',
        single: '<',
        direction: '@',
        close: '<',
        pricing: '<',
        titleTooltip: '@',
        localSearch: '<',
        handleLocalSearch: '&',
        disabled: '<',
        maxVisible: '<'
      },
      templateUrl: '/core/directives/input-users/input-users-directive.html?$$REVISION$$',
      controller: 'InputUsersController'
    }
  }
})()
